export default {
  name: 'menu1',
  components: {},
  data() {
    return {
      value: 3
    };
  }
};